import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {addHistory} from '../../redux/slices/pageHistorySlice';
import {RootState} from '../../redux/store';

const PageHistoryTracker = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const pageHistory = useSelector(
    (state: RootState) => state.pageHistory.history
  );

  useEffect(() => {
    if (pageHistory.length && pageHistory.at(-1) == location.pathname) return;
    dispatch(addHistory(location.pathname));
  }, [location.pathname, dispatch]);

  return null;
};

export default PageHistoryTracker;
